import { render, staticRenderFns } from "./calls-badge-state.vue?vue&type=template&id=f1240716&"
import script from "./calls-badge-state.vue?vue&type=script&lang=js&"
export * from "./calls-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports